"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNullOptional = exports.getNull = exports.getArrayOptionalNullable = exports.getArrayNullable = exports.getArrayOptional = exports.getArray = exports.getObjectOptionalNullable = exports.getObjectNullable = exports.getObjectOptional = exports.getObject = exports.getBooleanOptionalNullable = exports.getBooleanNullable = exports.getBooleanOptional = exports.getBoolean = exports.getIntegerOptionalNullable = exports.getIntegerNullable = exports.getIntegerOptional = exports.getInteger = exports.getNumberOptionalNullable = exports.getNumberNullable = exports.getNumberOptional = exports.getNumber = exports.getStringOptionalNullable = exports.getStringNullable = exports.getStringOptional = exports.getString = exports.assertUndefined = exports.assertNull = exports.assertArray = exports.assertObject = exports.assertBoolean = exports.assertInteger = exports.assertNumber = exports.isUndefinedOrNull = exports.isUndefined = exports.isNull = exports.isArray = exports.isObject = exports.isBoolean = exports.isInteger = exports.isNumber = exports.isString = exports.typeError = void 0;
function typeError(expectedType, value, valueName) {
    return new Error(`Expected ${valueName || 'value'} to be of type ${expectedType}. Got ${value}.`);
}
exports.typeError = typeError;
/**
 * Returns `true` if the value is a string.
 */
function isString(value) {
    return typeof value === 'string';
}
exports.isString = isString;
/**
 * Returns `true` if the value is a number and isn't `NaN`.
 */
function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
exports.isNumber = isNumber;
/**
 * Same as `isNumber`, but also checks that the number has no decimals.
 */
function isInteger(value) {
    return isNumber(value) && Math.round(value) === value;
}
exports.isInteger = isInteger;
/**
 * Returns `true` if the value is a boolean.
 */
function isBoolean(value) {
    return typeof value === 'boolean';
}
exports.isBoolean = isBoolean;
/**
 * Returns `true` if the value is a non-null object.
 */
function isObject(value) {
    return !!(value && typeof value === 'object');
}
exports.isObject = isObject;
/**
 * Returns `true` if the value is an array.
 */
function isArray(value) {
    return Array.isArray(value);
}
exports.isArray = isArray;
/**
 * Returns `true` if the value is `null`.
 */
function isNull(value) {
    return value === null;
}
exports.isNull = isNull;
/**
 * Returns `true` if the value is `undefined`.
 */
function isUndefined(value) {
    return typeof value === 'undefined';
}
exports.isUndefined = isUndefined;
/**
 * Returns `true` is the value is `undefined` or `null`.
 */
function isUndefinedOrNull(value) {
    return isUndefined(value) || isNull(value);
}
exports.isUndefinedOrNull = isUndefinedOrNull;
/**
 * Throws a type error if the value isn't a number.
 */
function assertNumber(value, valueName) {
    if (!isNumber(value)) {
        throw typeError('number', value, valueName);
    }
}
exports.assertNumber = assertNumber;
/**
 * Throws a type error if the value isn't an integer.
 */
function assertInteger(value, valueName) {
    if (!isInteger(value)) {
        throw typeError('integer', value, valueName);
    }
}
exports.assertInteger = assertInteger;
/**
 * Throws a type error if the value isn't a boolean.
 */
function assertBoolean(value, valueName) {
    if (!isBoolean(value)) {
        throw typeError('boolean', value, valueName);
    }
}
exports.assertBoolean = assertBoolean;
/**
 * Throws a type error if the value isn't an object.
 */
function assertObject(value, valueName) {
    if (!isObject(value)) {
        throw typeError('object', value, valueName);
    }
}
exports.assertObject = assertObject;
/**
 * Throws a type error if the value isn't an array.
 */
function assertArray(value, valueName) {
    if (!isArray(value)) {
        throw typeError('array', value, valueName);
    }
}
exports.assertArray = assertArray;
/**
 * Throws a type error if the value isn't `null`.
 */
function assertNull(value, valueName) {
    if (!isNull(value)) {
        throw typeError('array', value, valueName);
    }
}
exports.assertNull = assertNull;
/**
 * Throws a type error if the value isn't `undefined`.
 */
function assertUndefined(value, valueName) {
    if (!isUndefined(value)) {
        throw typeError('undefined', value, valueName);
    }
}
exports.assertUndefined = assertUndefined;
/**
 * Throws if `value` isn't a string.
 */
function getString(value, valueName) {
    if (typeof value !== 'string') {
        throw typeError('string', value, valueName);
    }
    return value;
}
exports.getString = getString;
/**
 * Throws if `value` isn't a string or undefined.
 */
function getStringOptional(value, valueName) {
    return isUndefined(value) ? value : getString(value, valueName);
}
exports.getStringOptional = getStringOptional;
/**
 * Throws if `value` isn't a string or null.
 */
function getStringNullable(value, valueName) {
    return isNull(value) ? value : getString(value, valueName);
}
exports.getStringNullable = getStringNullable;
/**
 * Throws if `value` isn't a string or null.
 */
function getStringOptionalNullable(value, valueName) {
    return isUndefinedOrNull(value) ? value : getString(value, valueName);
}
exports.getStringOptionalNullable = getStringOptionalNullable;
/**
 * Throws if `value` isn't a number.
 */
function getNumber(value, valueName) {
    if (typeof value !== 'number' || Number.isNaN(value)) {
        throw typeError('number', value, valueName);
    }
    return value;
}
exports.getNumber = getNumber;
/**
 * Throws if `value` isn't a number or undefined.
 */
function getNumberOptional(value, valueName) {
    return isUndefined(value) ? value : getNumber(value, valueName);
}
exports.getNumberOptional = getNumberOptional;
/**
 * Throws if `value` isn't a number or null.
 */
function getNumberNullable(value, valueName) {
    return isNull(value) ? value : getNumber(value, valueName);
}
exports.getNumberNullable = getNumberNullable;
/**
 * Throws if `value` isn't a number or null.
 */
function getNumberOptionalNullable(value, valueName) {
    return isUndefinedOrNull(value) ? value : getNumber(value, valueName);
}
exports.getNumberOptionalNullable = getNumberOptionalNullable;
/**
 * Throws if `value` isn't a number or if `value` is a decimal value.
 */
function getInteger(value, valueName) {
    assertInteger(value, valueName);
    return value;
}
exports.getInteger = getInteger;
/**
 * Throws if `value` isn't a number or undefined or if `value` is a decimal value.
 */
function getIntegerOptional(value, valueName) {
    return isUndefined(value) ? value : getInteger(value, valueName);
}
exports.getIntegerOptional = getIntegerOptional;
/**
 * Throws if `value` isn't a number or null or if `value` is a decimal value.
 */
function getIntegerNullable(value, valueName) {
    return isNull(value) ? value : getInteger(value, valueName);
}
exports.getIntegerNullable = getIntegerNullable;
/**
 * Throws if `value` isn't a number or null or if `value` is a decimal value.
 */
function getIntegerOptionalNullable(value, valueName) {
    return isUndefinedOrNull(value) ? value : getInteger(value, valueName);
}
exports.getIntegerOptionalNullable = getIntegerOptionalNullable;
/**
 * Throws if `value` isn't a boolean.
 */
function getBoolean(value, valueName) {
    if (typeof value !== 'boolean') {
        throw typeError('boolean', value, valueName);
    }
    return value;
}
exports.getBoolean = getBoolean;
/**
 * Throws if `value` isn't a boolean or undefined.
 */
function getBooleanOptional(value, valueName) {
    return isUndefined(value) ? value : getBoolean(value, valueName);
}
exports.getBooleanOptional = getBooleanOptional;
/**
 * Throws if `value` isn't a boolean or null.
 */
function getBooleanNullable(value, valueName) {
    return isNull(value) ? value : getBoolean(value, valueName);
}
exports.getBooleanNullable = getBooleanNullable;
/**
 * Throws if `value` isn't a boolean or null.
 */
function getBooleanOptionalNullable(value, valueName) {
    return isUndefinedOrNull(value) ? value : getBoolean(value, valueName);
}
exports.getBooleanOptionalNullable = getBooleanOptionalNullable;
/**
 * Throws if `value` isn't an object.
 */
function getObject(value, valueName) {
    if (value === null || typeof value !== 'object' || Array.isArray(value)) {
        throw typeError('object', value, valueName);
    }
    return value;
}
exports.getObject = getObject;
/**
 * Throws if `value` isn't an object or undefined.
 */
function getObjectOptional(value, valueName) {
    return isUndefined(value) ? value : getObject(value, valueName);
}
exports.getObjectOptional = getObjectOptional;
/**
 * Throws if `value` isn't an object or null.
 */
function getObjectNullable(value, valueName) {
    return isNull(value) ? value : getObject(value, valueName);
}
exports.getObjectNullable = getObjectNullable;
/**
 * Throws if `value` isn't an object or null.
 */
function getObjectOptionalNullable(value, valueName) {
    return isUndefinedOrNull(value) ? value : getObject(value, valueName);
}
exports.getObjectOptionalNullable = getObjectOptionalNullable;
/**
 * Throws if `value` isn't an array.
 */
function getArray(value, valueName) {
    if (!Array.isArray(value)) {
        throw typeError('array', value, valueName);
    }
    return value;
}
exports.getArray = getArray;
/**
 * Throws if `value` isn't an array or undefined.
 */
function getArrayOptional(value, valueName) {
    return isUndefined(value) ? value : getArray(value, valueName);
}
exports.getArrayOptional = getArrayOptional;
/**
 * Throws if `value` isn't an array or null.
 */
function getArrayNullable(value, valueName) {
    return isNull(value) ? value : getArray(value, valueName);
}
exports.getArrayNullable = getArrayNullable;
/**
 * Throws if `value` isn't an array or null.
 */
function getArrayOptionalNullable(value, valueName) {
    return isUndefinedOrNull(value) ? value : getArray(value, valueName);
}
exports.getArrayOptionalNullable = getArrayOptionalNullable;
/**
 * Throws if `value` isn't null.
 */
function getNull(value, valueName) {
    if (value !== null) {
        throw typeError('null', value, valueName);
    }
    return value;
}
exports.getNull = getNull;
/**
 * Throws if `value` isn't a string or undefined.
 */
function getNullOptional(value, valueName) {
    return isUndefined(value) ? value : getNull(value, valueName);
}
exports.getNullOptional = getNullOptional;
//# sourceMappingURL=validate.js.map